<script lang="ts">
    import { Router, Link, Route } from "svelte-routing";
    import { MaterialApp } from 'svelte-materialify';
    import { AppBar, Button, Container, Icon, Overlay, Dialog } from 'svelte-materialify/src';
    import { mdiMenu, mdiInformationOutline } from '@mdi/js';

    import SideBar from './SideBar.svelte';
    import About from './About.svelte';
    import Footer from './Footer.svelte';

    import patternLibrary from "./pattern/pattern-library";

    // ROUTES
    import { ROUTES } from "./routes/routes"
    import PageHome from "./routes/Home.svelte";
    import PageImprint from "./routes/Imprint.svelte";
    import PageNotFound from "./routes/NotFound.svelte";

    export let url = '';


    let showSideBar: boolean = false;
    const openSideBar = () => { showSideBar = true; }
    const closeSideBar = () => { showSideBar = false; }
    const toggleSideBar = () => {
        if (showSideBar) {
            closeSideBar();
        } else {
            openSideBar();
        }
    }

    let showAbout: boolean = false;

    // const checkMobile = () => {
    //     mobile = window.matchMedia(breakpoints['md-and-down']).matches;
    //     console.log('checkMobile?', mobile);
    // }


    let selectedPatternId: number = patternLibrary[0].id;

    const setCurrentPatternId = (patternId: number) => {
        selectedPatternId = patternId;
        closeSideBar();
    };

    const patternSelectItems = patternLibrary.map((pattern) => {
        return {
            name: pattern.name,
            value: pattern.id
        };
    });
</script>


<Router url="{url}">

    <MaterialApp theme="light">

        <AppBar class="primary-color white-text">
            <div slot="icon">
              <Button depressed fab text on:click={toggleSideBar}>
                <Icon path={mdiMenu} />
              </Button>
            </div>
            <span slot="title">
                Etch A Skratch
            </span>

            <div style="flex-grow:1" />

            <Button depressed fab text on:click={() => showAbout = true} title="About">
                <Icon path={mdiInformationOutline} />
            </Button>
        </AppBar>

        <SideBar show={showSideBar} setCurrentPatternId={setCurrentPatternId} closeSideBar={closeSideBar} />
        <Overlay index={1} active={showSideBar} on:click={closeSideBar} absolute />

        <main>

            <div style="background: #ffc107; color: #444; text-align: center; font-size: 12px; padding: 5px;">
                <em>This is an experimental prototype. Expect changes, bugs and glitches.</em>
            </div>

            <Container>

                <Route path="{ROUTES.IMPRINT}" component="{PageImprint}" />
                <Route path="{ROUTES.HOME}"><PageHome {selectedPatternId} /></Route>

                <Route><!-- default catch-all route, sadly returns 200 as well -->
                    <PageNotFound />
                </Route>

            </Container>
        </main>

        <Dialog class="pa-5" bind:active={showAbout}>
            <About />
        </Dialog>

        <Footer />

    </MaterialApp>

</Router>
